if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      // Initialize scroll position variable
      this.addToBagPosition = 0;
      this.isPositionSaved = false;
      this.lastScrollTop = 0;

      this.isGiftCardTemplate = document.querySelectorAll('e-gift-card').length > 0 ? true : false;


      this.initTruefitAutoSizeSelection();

      if (this.isGiftCardTemplate) {

        this.inputTypeName = document.querySelector('e-gift-card [data-input-type="name"] input');
        this.inputTypeEmail = document.querySelector('e-gift-card [data-input-type="email"] input');
        this.inputTypeMessage = document.querySelector('e-gift-card [data-input-type="message"] textarea');
        this.inputTypeFrom = document.querySelector('e-gift-card [data-input-type="from"] input');
        this.inputTypeDate = document.querySelector('e-gift-card [data-input-type="date"] input');
        
        // Add event listeners to detect when a user leaves an input field
        this.inputTypeName.addEventListener('focusout', evt => this.validateGCInput(evt.target, evt));
        this.inputTypeEmail.addEventListener('focusout', evt => this.validateGCInput(evt.target, evt));
        this.inputTypeMessage.addEventListener('focusout', evt => this.validateGCInput(evt.target, evt));
        this.inputTypeFrom.addEventListener('focusout', evt => this.validateGCInput(evt.target, evt));
        this.inputTypeDate.addEventListener('focusout', evt => this.validateGCInput(evt.target, evt));

        // Add event listeners to detect when a user start typing 
        this.inputTypeMessage.addEventListener('input', (evt) => {
          this.countCharactersOnInput(evt.target);
        });
      }
    }

    initTruefitAutoSizeSelection() {
      const getRecommendationTextFromDetail = (recommendation) => {
        if (!recommendation) return '';
        if (typeof recommendation === 'string') return recommendation;

        const message = typeof recommendation.message === 'string' ? recommendation.message.trim() : '';
        const size = typeof recommendation.size === 'string' ? recommendation.size.trim() : '';

        if (message && size && !message.toLowerCase().includes(size.toLowerCase())) {
          return `${message} ${size}`;
        }

        return message || size;
      };

      const applyTruefitSizeSelection = (recommendation) => {
        const recommendationText = getRecommendationTextFromDetail(recommendation);
        if (!recommendationText || typeof recommendationText !== 'string') return;

        const normalized = recommendationText.trim().replace(/^recommended\s+size:\s*/i, '');
        const sizeParts = normalized.split(/\s+/).filter(Boolean);
        if (sizeParts.length === 0) return;

        const sizePart = sizeParts[sizeParts.length - 1].toLowerCase();
        const fitPart = sizeParts.length > 1 ? sizeParts.slice(0, -1).join(' ').toLowerCase() : null;

        const enabledFitInputs = Array.from(document.querySelectorAll('input[name="Fit"]'))
          .filter(input => !input.disabled);
        const enabledSizeInputs = Array.from(document.querySelectorAll('input[name="Size"]'))
          .filter(input => !input.disabled);

        if (enabledSizeInputs.length === 0) return;

        // Match Fit input if it exists (e.g. "Regular")
        if (fitPart && enabledFitInputs.length > 0) {
          enabledFitInputs.forEach(input => {
            if (input.value.trim().toLowerCase() === fitPart) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }

        // Match Size input (e.g. "10")
        enabledSizeInputs.forEach(input => {
          if (input.value.trim().toLowerCase() === sizePart) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      };

      if (typeof tfcapi === 'function') {
        tfcapi('event', 'tfc-fitrec-product', 'autoSizeSelect', (e) => {
          if (!e || !e.size || typeof e.size !== 'string') return;
          applyTruefitSizeSelection(e);
        });
      }

      window.addEventListener('truefit:recommendation', (event) => {
        const detail = event?.detail || {};
        applyTruefitSizeSelection(detail);
      });
    }

    showErrorMessages(submitButton) {
      let allFieldSet = document.querySelectorAll('variant-radios fieldset');
      let firstError = null;
      let firstErroredFieldset = null;

      if (allFieldSet) {
        allFieldSet.forEach(fieldset => {
          const errorSpan = fieldset.nextElementSibling.querySelector('span');
          if (!this.isFieldSetSelected(fieldset)) {
            errorSpan.classList.remove('hidden');
            if (submitButton && submitButton.classList.contains("swymcs-wishlist-button")) {
              submitButton.setAttribute("aria-disabled", "true");
            }
            if (!firstError) {
              firstError = errorSpan;
              firstErroredFieldset = fieldset;
            }
          } else {
            if (submitButton && submitButton.classList.contains("swymcs-wishlist-button")) {
              submitButton.setAttribute("aria-disabled", "false");
            }
            errorSpan.classList.add('hidden');
          }
        });
      }

      if (firstErroredFieldset) {
        const input = firstErroredFieldset.querySelector('input[type="radio"]');
        if (input) {
          input.focus();
        }
      }
      if (
        firstError &&
        submitButton.classList.contains('swymcs-wishlist-button--media')
      ) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    handleErrorMessageWith422Response(response) {
      // Soldout message with a 422 status happens if we have more than 1 stock and that is in cart
      // All products are in your cart message with a 422 status happens if we have only 1 stock and that is in cart
      if (response.status === 422 || (response.description.toLowerCase().includes('sold out') || response.description.toLowerCase().includes('are in your cart') || response.description.toLowerCase().includes('is already in your cart'))) {
        // Hide error messages pertaining to non selection of input fields
        let allFieldSet = document.querySelectorAll('variant-radios fieldset');
        if(allFieldSet) {
          allFieldSet.forEach(fieldset => {
            fieldset.nextElementSibling.querySelector('span').classList.add('hidden');
          });
        }
      }
    }

    setTimeStampToItem(event)  {
      const nowString = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
      // This has been added to provide a unique line item property to separate the same cart items for backend processes
      const uniqueLineItemProperty = event.target.querySelector('[name="properties[_UniqueLineItemProperty]"]');
      
      if (uniqueLineItemProperty) {
        uniqueLineItemProperty.setAttribute('value', nowString);
      }
    }

  // Return null or any default value if no inputs found
    isFieldSetSelected(fieldset) {
      let allFieldsetInputs = fieldset.querySelectorAll('input');
      if (allFieldsetInputs) {
        let inputArray = [...allFieldsetInputs];
        let checkedInput = inputArray.filter(input => input.checked);
        return checkedInput.length > 0 ? checkedInput[0] : null;
      }
      return null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitter = evt.submitter; // <- the button used to submit

      this.showErrorMessages(submitter);
       // If the submitter is the wishlist button, bail out
      if (submitter && submitter.classList.contains("swymcs-wishlist-button")) {
        return;
      }

      this.setTimeStampToItem(evt);
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const formData = new FormData(this.form);
      
      if (this.isGiftCardTemplate && !this.areAllInputsValid()) {
        this.initGiftCardValidation();
        if (formData.getAll('id')[0] != '') return;
      }

      if (formData.getAll('id')[0] == '') return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // Select all elements with the attribute [data-item-qty="0"]
      const itemsWithZeroQty = this.cart.querySelectorAll('[data-item-qty="0"]');

      // Check if there are any such items
      if (itemsWithZeroQty.length > 0) {
        // If there are, remove the 'hidden' class from the message element
        const removedItemMessage = this.cart.querySelector('.cart-drawer__removed-item-message');
        if (removedItemMessage) {
          removedItemMessage.classList.remove('hidden');
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {

            this.handleErrorMessage(response);
            this.handleErrorMessageWith422Response(response);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          this.cart.renderContents(response);

          const successMessage = document.querySelector('#AddToCartSuccessMessage span');
          if (successMessage) {
            successMessage.textContent = window.cartStrings.success;
          }

          // Check if there are any such items
          if (itemsWithZeroQty.length > 0) {
            // If there are, remove the 'hidden' class from the message element
            const removedItemMessage = this.cart.querySelector('.cart-drawer__removed-item-message');
            if (removedItemMessage) {
              removedItemMessage.classList.remove('hidden');
            }
          }

          // DATALAYER (ADD TO CART)
          try {
            const dataLayerScript = document.querySelector('.datalayer-add-to-cart');
    
            if (dataLayerScript) {
              const scriptContent = JSON.parse(dataLayerScript.textContent);

              // Set cta_location based on whether click came from sticky bar
              scriptContent.cta_location = window.__stickyATCClick ? 'sticky' : 'main';
              window.__stickyATCClick = false;

              if (response.variant_options[1] === undefined) {
                scriptContent.variantId.splice(2, 1);
                scriptContent.variantId[0] = response.variant_options[0];
              } else {
                scriptContent.variantId[0] = response.variant_options[1];
                scriptContent.variantId[2] = response.variant_options[0];
              }

              if (response.properties) {
                scriptContent.variantId[3] = response.properties["_variant_edp"];
              }

              scriptContent.quantity = 1;
    
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(scriptContent);
    
            } else {
              throw new Error('DataLayer script element for add to cart not found');
            }
          } catch (error) {
            console.error('Error pushing to dataLayer:', error);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        // Soldout message with a 422 status happens if we have more than 1 stock and that is in cart
        // All products are in your cart message with a 422 status happens if we have only 1 stock and that is in cart
        if (errorMessage.status === 422 || errorMessage.toLowerCase().includes('sold out') || 
            errorMessage.toLowerCase().includes('are in your cart') || 
            errorMessage.toLowerCase().includes('is already in your cart')) {
          this.errorMessage.textContent = this.errorMessage.dataset.message;
        } else {
          this.errorMessage.classList.add('hidden');
        }

        // Scroll to the error message if it's not visible in the viewport
        if (!this.isElementVisible(this.errorMessageWrapper)) {
          this.errorMessageWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    isElementVisible(element) {
      let rect = element.getBoundingClientRect();
      let windowHeight = window.innerHeight || document.documentElement.clientHeight;
      let windowWidth = window.innerWidth || document.documentElement.clientWidth;
      let verticallyVisible = rect.top <= windowHeight && rect.bottom >= 0;
      let horizontallyVisible = rect.left <= windowWidth && rect.right >= 0;
      return verticallyVisible && horizontallyVisible;
    }

    getInputType(gCInput) {
      return gCInput.closest('.input-item-wrapper').getAttribute('data-input-type');
    }

    getInput(gCInput) {
      switch (this.getInputType(gCInput)) {
        case 'message':
          return gCInput.querySelector('textarea');
        default:
          return gCInput.querySelector('input');
      }
    }

    initGiftCardValidation() {
      this.validateGCInput(this.inputTypeName);
      this.validateGCInput(this.inputTypeEmail); 
      this.validateGCInput(this.inputTypeMessage); 
      this.validateGCInput(this.inputTypeFrom);
      this.validateGCInput(this.inputTypeDate);
    }

    renderErrorMessage(input) {

      let emptyField = input.getAttribute('data-empty-input');
      let validationMessage = input.getAttribute('data-validation-error');

      if(input.value.length == 0) {
        input.closest('div').querySelector('.boden-input__text--label span').innerText = emptyField;
      } else {
        input.closest('div').querySelector('.boden-input__text--label span').innerText = validationMessage;
      }

    }

    validateGCInput(gCInput, event = null) {
      const _type = this.getInputType(gCInput);

      if (this.isValidInput(gCInput, _type)) {
        this.removeErrorClass(gCInput);
        this.hideLabel(gCInput);
      } else {
        this.addErrorClass(gCInput);
        this.showLabel(gCInput);
        this.renderErrorMessage(gCInput);
      }
    }

    removeErrorClass(input) {
      input.classList.remove('boden-input__text--error');
      input.classList.add('boden-input__text');
    }

    addErrorClass(input) {
      input.classList.remove('boden-input__text');
      input.classList.add('boden-input__text--error');
    }

    hideLabel(input) {
      input.closest('div').querySelector('.boden-input__text--label').classList.add('hidden');
    }

    showLabel(input) {
      input.closest('div').querySelector('.boden-input__text--label').classList.remove('hidden');
    }

    isValidInput(input, type) {
      let regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
      input.value = input.value.replace(/^\s+/, '');

      switch (type) {
        case 'name':
          regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
          break;
        case 'email':
          regexPattern = /^([a-zA-Z0-9_\-.+]+)@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.)|(([a-zA-Z0-9-]+.)+))([a-zA-Z]{2,}|[0-9]{1,3})(]?)$/;
          break;
        case 'message':
          regexPattern = /^[a-zA-Z0-9 ~`!@#$%^&*()_+?:"{}[\];'‘’“”éàèùâêîôûçëïüÉÀÈÙÂÊÎÔÛÇËÏÜÄäÖöÜüß\s,;:.\-]+$/;
          break;
        case 'from':
          regexPattern = /^(?!^\s)[\wÀ-ÿ-\u0390-\u03CE\u3040-\u309F. ]+$/;
          break;
        case 'date':
          regexPattern = '';
          break;
      }

      let isValid;
      if (input.hasAttribute('required')) {
        isValid = regexPattern.test(input.value);
      }

      if (!input.hasAttribute('required')) {
        return true;
      } else if (input.value.length === 0) {
        return false;
      } else {
        return isValid;
      }
    }

    areAllInputsValid() {
      return !!(this.isValidInput(this.inputTypeName, 'name') &&
        this.isValidInput(this.inputTypeEmail, 'email') &&
        this.isValidInput(this.inputTypeFrom, 'from') &&
        this.isValidInput(this.inputTypeMessage, 'message') &&
        this.isValidInput(this.inputTypeDate, 'date'));
    }

    countCharactersOnInput(target) {
      const maxLength = parseInt(target.getAttribute("maxlength"));
      let currentLength = maxLength - target.value.length;
      target.closest('div').querySelector('.word-count').innerText = currentLength;
    }
  });
}
